module.exports = __webpack_public_path__ + "img/digital_card_winter.eba7bece.png";